import _ from "lodash";
import React from "react";

import {
  ChecklistDropdown,
  FilterLabelButton,
  Modal,
  SearchInput,
} from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";

import classes from "./ManageMembersTab.scss";
import { getLabelValueForMultiFilterLabelButton, isIdEqual } from "Utils";
import { PARENT, STAFF, STUDENT } from "Constants/stringConstants";
import { useDispatch } from "Hooks/useDispatch";
import {
  handleRemoveUserFromChannel,
  handleRemoveUserFromDepartmentChannel,
} from "MessagingV2/modules/MessagingModule";
import { CHAT_TYPE_ENUM } from "MessagingV2/modules/Utils";

import MemberList from "./MemberList";

const styles = {
  modalBodyStyles: {
    padding: "0px",
    overflow: "hidden",
  },
};

const getUserTypeOption = ({ t, channelType }) => {
  const options = [
    {
      value: STAFF,
      label: t("common:staff"),
    },
    {
      value: STUDENT,
      label: t("common:student_other"),
      hiddenChannelType: [
        CHAT_TYPE_ENUM.CHANNEL_FAMILY,
        CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT,
      ],
    },
    {
      value: PARENT,
      label: t("common:family_plural"),
      hiddenChannelType: [CHAT_TYPE_ENUM.CHANNEL_SYSTEM_MANAGED],
    },
  ];

  return _.filter(options, option => {
    return (
      _.isEmpty(option.hiddenChannelType) ||
      !_.includes(option.hiddenChannelType, channelType)
    );
  });
};

const ManageMembersTab = props => {
  const {
    isMemberUpdate,
    users,
    chatId,
    showAddMemberButton,
    onAddMember,
    channelType,
    createdBy,
    canManageChannel,
    canBlockUser,
  } = props;
  const { t } = useI18n(["common"]);
  const [searchText, setSearchText] = React.useState("");
  const userTypes = getUserTypeOption({ t, channelType });
  const [selectedUserTypes, setUserTypes] = React.useState(
    _.map(userTypes, "value")
  );

  const dispatch = useDispatch();

  const isDepartmentChannel = _.isEqual(
    channelType,
    CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT
  );

  const handleRemoveUser = ({ user, callback }) => {
    const updatedCurrentUsers = _.filter(users, u => {
      return !isIdEqual(user.id, u.id);
    });
    if (isDepartmentChannel) {
      dispatch(
        handleRemoveUserFromDepartmentChannel({
          chatId,
          users: updatedCurrentUsers,
          removedUser: user,
          callback,
        })
      );
    } else {
      dispatch(
        handleRemoveUserFromChannel({
          chatId,
          users: updatedCurrentUsers,
          removedUser: user,
          callback,
        })
      );
    }
  };

  return (
    <Modal.Body style={styles.modalBodyStyles}>
      <div className={classes.searchAndFilterContainer}>
        <SearchInput
          dsVersion="2.0"
          size="medium"
          placeholder={t("common:search_placeholder")}
          onChange={setSearchText}
          value={searchText}
          autoFocus
        />
        <ChecklistDropdown
          options={userTypes}
          showAllOption
          value={selectedUserTypes}
          onChange={setUserTypes}
          showSelectedOptionsOnTop={false}
          dsVersion="2.0"
        >
          <FilterLabelButton
            dsVersion="2.0"
            size="medium"
            variant="neutral"
            type="outlined"
            label={t("common:user_other")}
            labelValue={getLabelValueForMultiFilterLabelButton({
              selectedOptions: selectedUserTypes,
              options: userTypes,
              t,
              noneText: t("common:all"),
            })}
          />
        </ChecklistDropdown>
      </div>
      <div className={classes.membersListContainer}>
        <MemberList
          searchText={searchText}
          userType={selectedUserTypes}
          canUpdateMember={isMemberUpdate}
          onRemoveUser={handleRemoveUser}
          showAddMemberButton={showAddMemberButton}
          onAddMember={onAddMember}
          canManageChannel={canManageChannel}
          createdBy={createdBy}
          canBlockUser={canBlockUser}
          isDepartmentChannel={isDepartmentChannel}
        />
      </div>
    </Modal.Body>
  );
};

export default ManageMembersTab;
